/* eslint-disable no-underscore-dangle */
/* eslint-disable object-curly-spacing */
/* eslint-disable key-spacing */
/* eslint-disable quotes */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Drawer from '@mui/material/Drawer';
import PersonIcon from '@mui/icons-material/Person';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import MenuItem from '@mui/material/MenuItem';
import Card from '@mui/material/Card';
import { useDispatch, useSelector } from 'react-redux';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { makeStyles } from '@mui/styles';
import i18n from '../../i18n';
import Controls from '../../components/controls';
import { setUser } from '../../components/header/setUser';
import SearchMaskInput from './SearchInput';
import DialogBox from '../DialogBox';
import { emptyCart } from '../../services/placeOrder/getDefaultCart';
import './header.scss';
import eventBus from '../../constants/eventBus';


const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  cardHeader: {
    padding: 0,
    '& .MuiCardHeader-title': {
      fontSize: '18px',
      paddingBottom: '5px',
    },
  },
  cardContent: {
    padding: '15px 15px 0',
  },
  cardAction: {
    padding: '15px',
  },
  accountList: {
    marginLeft: '30px',
    '& li': {
      color: '#008000',
      listStyle: 'square',
    },
  },
  accountName: {
    height: '40px',
    lineHeight: '20px',
    fontSize: '14px',
  },
  font14: {
    fontSize: '14px',
  },
  userdata: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      width: '65%',
      maxWidth: '65%',
    },
  },
  topBarSpan: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '200px',
    [theme.breakpoints.up('lg')]: {
      width: '95%',
    },
  },
  currentAccountCard: {
    border: '3px solid #008000',
    backgroundColor: '#f5f5f5',
    position: 'relative',
  },
  currentAccountActions: {
    justifyContent: 'center',
    padding: '15px',
    backgroundColor: '#fafafa',
    cursor: 'default',
  },
  currentAccountLabel: {
    color: '#008000',
    fontWeight: 'bold',
    fontSize: '14px',
    textAlign: 'center',
  },
  selectableAccountCard: {
    border: '1px solid #e0e0e0',
    '&:hover': {
      borderColor: '#ccc',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
  },
}));

export default function TemporaryDrawer(props) {
  const dispatch = useDispatch();
  const { loginUserInfo, user } = props;
  const classes = useStyles();
  const userAccounts = loginUserInfo?.CP_USER_PERMISSIONS && JSON.parse(loginUserInfo?.CP_USER_PERMISSIONS);
  const { enableSwitchAccount, enableSwitchAccountDialog, acceptClearPopup } = useSelector(state => state?.headerProductSearch);
  const accounts = loginUserInfo?._accounts && loginUserInfo?._accounts?.[0]?._element;
  const isCSR = loginUserInfo?.CP_IS_CSR === 'Y';
  const isSalesRep = loginUserInfo?.CP_IS_SALESREP === 'Y';
  const cartItems = useSelector(state => state?.cartDetails?.cartItems || []);
  const { EmptyCartEndpoint } = useSelector(state => state?.cartDetails);
  const [cartClearNotify, setcartClearNotify] = useState(false);
  const [pendingAccount, setPendingAccount] = useState(null);
  const location = useLocation();

  useEffect(() => {
    dispatch({ type: 'IS_CSR', payload: isCSR });
    dispatch({ type: 'IS_SALES_REP', payload: isSalesRep });
  }, []);

  const toggleDrawer = open => (event) => {
    event?.preventDefault();
    if (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift')) {
      return;
    }
    dispatch({ type: 'ENABLE_SWITCH_ACCOUNT', payload: open });
  };

  const handleCloseDrawer = () => {
    dispatch({ type: 'ENABLE_SWITCH_ACCOUNT', payload: false });
  };

  const proceedWithAccountSwitch = (acc) => { 
    localStorage.setItem('customerAPCurrency', acc?.AP_CURRENCY_CODE ? acc?.AP_CURRENCY_CODE : '');
    dispatch({ type: 'SHIP_TO_SITE_ADDRESS_ID', payload: 0 });
    dispatch({ type: 'SHIP_TO', payload: [] });
    if (!isSalesRep) {
      dispatch({ type: 'ORDER_TYPE', payload: null });
    }
    dispatch({ type: 'DEFAULT_CART_ID', payload: '' });
    dispatch({ type: 'ACCOUNT_SWITCHED', payload: true });
    localStorage.removeItem('savedCartItems');
    dispatch(setUser({ ...acc, userpermission: acc?.userpermission }));
    localStorage.setItem('defaultUserID', acc?.AP_ACCOUNT_NUMBER);
    const accountInfo = {
      accountNum: acc?.AP_ACCOUNT_NUMBER?.trim(),
      accountId: acc?.AP_CUST_ACCOUNT_ID?.trim(),
      accountName: acc?.AP_CUSTOMER_NAME?.trim(),
    };
    // document.cookie = 'selectedAccount=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    document.cookie = `selectedAccount=${JSON.stringify(accountInfo)}; path=/`;
    ["dvaCreditClaims", "dva_partner_locations", "dva_partner_locations_expiry"]
      .forEach((key) => sessionStorage.removeItem(key));
    dispatch({ type: 'ENABLE_SWITCH_ACCOUNT', payload: false });
  };

  // const handleConfirmAccountSwitch = () => {
  //   if (pendingAccount && acceptClearPopup) {
  //     const clearCartPromise = cartItems.length > 0
  //       ? emptyCart(EmptyCartEndpoint)
  //       : Promise.resolve();

  //     clearCartPromise.then(() => {
  //       setcartClearNotify(false);
  //       proceedWithAccountSwitch(pendingAccount);
  //     }).catch(err => {
  //       proceedWithAccountSwitch(pendingAccount);
  //       setcartClearNotify(false);
  //     });
  //   }
  // };
  useEffect(() => {
    if (pendingAccount && acceptClearPopup) {
      proceedWithAccountSwitch(pendingAccount);
      dispatch({ type: 'ACCEPT_CLEAR_POPUP', payload: false });
    }
  }, [acceptClearPopup, pendingAccount])

  const handleCancelAccountSwitch = () => {
    setcartClearNotify(false);
  };

  const selectAccount = (acc) => {
    if (user?.accountNumber === acc?.AP_ACCOUNT_NUMBER) {
      dispatch({ type: 'ENABLE_SWITCH_ACCOUNT', payload: false });
      eventBus.emit('openShipToDialog');
      return;
    }

    const hasCartItems = cartItems && cartItems.length > 0;
    
    if (hasCartItems && location.pathname === '/order') {
      setPendingAccount(acc);
      // setcartClearNotify(true);
      dispatch({ type: 'ENABLE_SWITCH_ACCOUNT_DIALOG', payload: true });
      return;
    }
    
    proceedWithAccountSwitch(acc);
    eventBus.emit('openShipToDialog');
  };

  const getAccount = accountId => accounts?.filter(el => el?.AP_ACCOUNT_NUMBER === accountId);

  return (
    <div className={classes.topBar}>
      <React.Fragment>
        {userAccounts && (userAccounts.length > 1 || isCSR || isSalesRep) ?
          <a className={classes?.userdata} href="#." onClick={toggleDrawer(true)}>
            <span><PersonIcon /></span>
            <span className={classes?.topBarSpan}>{i18n.t('switchAccount.userWelcome')} {loginUserInfo && loginUserInfo?.['given-name']} ( {user && user?.accountName}, {user && user?.accountNumber} )
            </span>
            <span className="d-flex"> <ExpandMoreIcon /></span>
          </a>
          :
          <a className={classes?.userdata} href="#">
            <span><PersonIcon /></span>
            <span className={classes?.topBarSpan}>{i18n.t('switchAccount.userWelcome')} {loginUserInfo && loginUserInfo?.['given-name']} ( {user && user?.accountName}, {user && user?.accountNumber} )</span>
          </a>
        }
        <Drawer
          anchor="top"
          open={enableSwitchAccount}
          onClose={toggleDrawer(false)}
          className="drawer-scroll-fix"
          ModalProps={{
            style: { zIndex: 2000 }, // make modal root above other dialogs
            BackdropProps: { style: { zIndex: 1999 } }, // backdrop just below the drawer content
          }}
          PaperProps={{ style: { zIndex: 2001 } }} // drawer paper itself above the modal root
        >
          <MenuItem className="drawerTop" onClick={handleCloseDrawer}><CloseIcon fontSize="small" /></MenuItem>
          <Typography variant="h5" component="h5" align="center" className="pt-10">
            {i18n.t('switchAccount.selectAccount')}
          </Typography>
          <Grid container spacing={3} justifyContent="center" alignItems="stretch" className="p-20 no-margin">
            {userAccounts && userAccounts.map((account, index) => {
              const userInfo = getAccount(account?.XREF_CUSTOMER_NUM)?.[0] || {};
              userInfo.userpermission = account;
              return (
                <React.Fragment key={account?.XREF_CUSTOMER_NUM}>
                  {userInfo?.AP_CUSTOMER_NAME &&
                    <Grid item xs={6} md={3} key={account?.XREF_CUSTOMER_NUM} style={{paddingTop:"11px"}}>
                      <Card 
                        className={`${classes?.root} ${user?.accountNumber === account?.XREF_CUSTOMER_NUM ? classes?.currentAccountCard : classes?.selectableAccountCard}`} 
                        variant="outlined"
                      >
                        <CardContent className={classes?.cardContent}>
                          <CardHeader className={`switchCardHeader ${classes?.cardHeader}`} title={`${i18n?.t("returnHistory.invoiceDetails.account")}: ${account?.XREF_CUSTOMER_NUM || ""}`} />
                          <Typography variant="subtitle1" className={classes?.accountName}>
                            {i18n?.t('common.labels.name')}: {userInfo?.AP_CUSTOMER_NAME}
                          </Typography>
                          <Typography variant="subtitle1" className={classes?.font14}>
                            {i18n?.t('switchAccount.accountAccess')}:
                          </Typography>
                          <ul className={`${classes?.accountList} ${classes?.font14}`}>
                            {account?.IS_ACTIVE_DS && account?.IS_ACTIVE_DS === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.dropShip')}
                              </li>
                            }
                            {account?.IS_ACTIVE_HME && account?.IS_ACTIVE_HME === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.standard')}
                              </li>
                            }
                            {(account?.AUTH_CARELINK_ORDER && account?.AUTH_CARELINK_ORDER === 'Y' || account?.IS_ACTIVE_CARELINK === 'Y') &&
                              <li>
                                {i18n?.t('switchAccount.orderType.carelink')}
                              </li>
                            }
                            {account?.IS_ACTIVE_MG && account?.IS_ACTIVE_MG === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.maskGuarantee')}
                              </li>
                            }
                            {account?.IS_ACTIVE_OCI && account?.IS_ACTIVE_OCI === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.OCI')}
                              </li>
                            }
                            {account?.IS_ACTIVE_RMA && account?.IS_ACTIVE_RMA === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.RMA')}
                              </li>
                            }
                            {account?.IS_ACTIVE_RSVP && account?.IS_ACTIVE_RSVP === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.rsvp')}
                              </li>
                            }
                            {account?.IS_ACTIVE_SERVICE_CENTRE_ACC && account?.IS_ACTIVE_SERVICE_CENTRE_ACC === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.serviceCenter')}
                              </li>
                            }
                            {account?.IS_ACTIVE_SERVICE_REQUEST && account?.IS_ACTIVE_SERVICE_REQUEST === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.serviceRequest')}
                              </li>
                            }
                            {account?.IS_ACTIVE_CREDIT_CLAIM_DVA && account?.IS_ACTIVE_CREDIT_CLAIM_DVA === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.creditClaimDVA')}
                              </li>
                            }
                            {account?.IS_ACTIVE_CREDIT_CLAIM_STD && account?.IS_ACTIVE_CREDIT_CLAIM_STD === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.creditClaimSTD')}
                              </li>
                            }
                            {account?.IS_ACTIVE_ONLINE_BILL && account?.IS_ACTIVE_ONLINE_BILL === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.onlinePayment')}
                              </li>
                            }
                            {account?.IS_ACTIVE_HME_VIEW_ONLY && account?.IS_ACTIVE_HME_VIEW_ONLY === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.standardViewOnly')}
                              </li>
                            }
                            {account?.IS_ACTIVE_RMA_VIEW_ONLY && account?.IS_ACTIVE_RMA_VIEW_ONLY === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.RMAViewOnly')}
                              </li>
                            }
                            {account?.IS_ACTIVE_SAMPLES && account?.IS_ACTIVE_SAMPLES === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.samples')}
                              </li>
                            }
                            {account?.IS_ACTIVE_STANDARD_PRICELESS && account?.IS_ACTIVE_STANDARD_PRICELESS === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.standardPriceless')}
                              </li>
                            }
                            {account?.IS_ACTIVE_WARRANTY_LOOKUP && account?.IS_ACTIVE_WARRANTY_LOOKUP === 'Y' &&
                              <li>
                                {i18n?.t('switchAccount.orderType.warrantyLookUp')}
                              </li>
                            }
                          </ul>
                        </CardContent>
                        <CardActions className={`justifyCenter ${user?.accountNumber === account?.XREF_CUSTOMER_NUM ? classes?.currentAccountActions : classes?.cardAction}`}>
                          {user?.accountNumber === account?.XREF_CUSTOMER_NUM ? (
                            <Typography className={classes?.currentAccountLabel}>
                              {i18n.t("switchAccount.currentContext")}
                            </Typography>
                          ) : (
                            <Controls.Button size="small" id={`multi-account-${index}`} variant="outlined" text={i18n.t("warrantyLookup.warrantyFormLabelSelectAccount")} onClick={() => selectAccount(userInfo)} />
                          )}
                        </CardActions>
                      </Card>
                    </Grid>}
                </React.Fragment>
              );
            })}
            {(isCSR || isSalesRep) &&
              <Grid item xs={6} md={6}>
                <SearchMaskInput selectAccount={selectAccount} />
              </Grid>
            }
          </Grid>
          {/* <Grid item xs={12} lg={12}>
            <DialogBox
              title={i18n.t('placeOrder.rosConfirmation')}
              cancelLable={i18n.t('placeOrder.buttonsLabel.cancel')}
              saveLable={i18n.t('placeOrder.buttonsLabel.continue')}
              footerStyle="footerContainerRight"
              onSave={handleConfirmAccountSwitch}
              onCancel={handleCancelAccountSwitch}
              openDialog={cartClearNotify}
              width="xs"
              zIndex={2100}
            >
              <Grid xs={12} container item className={classes.AddionalProductContent}>
                <Grid container>
                  <Grid item xs={12} className="mb-20">
                    <span>{i18n.t('placeOrder.clearCart')}</span>
                  </Grid>
                </Grid>
              </Grid>
            </DialogBox>
          </Grid> */}
        </Drawer>
      </React.Fragment>
    </div>
  );
}
